 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTML01_COPYRIGHT from '@/components/xhtml/01_Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML03_ABBREVIATION from '@/components/xhtml/03_Abbreviation'
 import XHTML04_INTODUCTION from '@/components/xhtml/04_Intoduction'
 import XHTML05_CHAPTER_001 from '@/components/xhtml/05_Chapter_001'
 import XHTML06_CHAPTER_002 from '@/components/xhtml/06_Chapter_002'
 import XHTML07_CHAPTER_003 from '@/components/xhtml/07_Chapter_003'
 import XHTML08_CHAPTER_004 from '@/components/xhtml/08_Chapter_004'
 import XHTML09_CHAPTER_005 from '@/components/xhtml/09_Chapter_005'
 import XHTML10_SELECTEDBIBLIOGRAPHY from '@/components/xhtml/10_Selectedbibliography'
 import XHTML11_NOTES from '@/components/xhtml/11_Notes'
 import XHTML12_ACKNOWLEDGMENT from '@/components/xhtml/12_Acknowledgment'
 import XHTML13_AOUTHOR from '@/components/xhtml/13_Aouthor'
 import XHTML14_PLATE from '@/components/xhtml/14_Plate'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/01_Copyright",
 			"name" : "xhtml/01_Copyright",
 			"component" : XHTML01_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/03_Abbreviation",
 			"name" : "xhtml/03_Abbreviation",
 			"component" : XHTML03_ABBREVIATION
 		},
 		{
 			"path" : "/xhtml/04_Intoduction",
 			"name" : "xhtml/04_Intoduction",
 			"component" : XHTML04_INTODUCTION
 		},
 		{
 			"path" : "/xhtml/05_Chapter_001",
 			"name" : "xhtml/05_Chapter_001",
 			"component" : XHTML05_CHAPTER_001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js